import SetUpLocation from "./SetUpLocation";

export { SetUpLocation };
